import { render, staticRenderFns } from "./Sagging.vue?vue&type=template&id=3987a75a"
import script from "./Sagging.vue?vue&type=script&lang=js"
export * from "./Sagging.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports